<script lang="ts">
  import { formatDate } from "$app/utils"
  import workAnniversaryImg from "@images/users/work-anniversary.png"

  let props = $props()
  let { workAnniversaries } = props
</script>

{#if workAnniversaries?.length > 0}
  <div class="shadow-lg mb-4">
    <div class="p-8 px-14 bg-yellow-50 rounded-lg">
      <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
        <div class="space-y-4 text-center">
          <img
            src={workAnniversaryImg}
            alt="Work Anniversary"
            class="size-36 mx-auto"
          />
          <h3 class="font-bold text-yellow-800 text-xl">
            Celebrating Work Anniversaries!
          </h3>
        </div>
        <div class="lg:col-span-2">
          <h3 class="font-bold text-yellow-700 text-xl text-center">
            Team member work anniversaries this week
          </h3>
          <ul
            class="mx-auto mt-4 max-w-2xl gap-x-12 gap-y-6 text-center lg:max-w-none flex justify-center items-center"
          >
            {#each workAnniversaries as work_anniversary}
              <li class="text-center">
                <img
                  src={work_anniversary.user.avatar_url}
                  alt={work_anniversary.user.name}
                  class="mx-auto h-14 w-14 text-sm rounded-full shadow-xl border border-gray-100"
                />

                <div class="font-bold">{work_anniversary.user.name}</div>
                <div class="text-sm">
                  {formatDate(work_anniversary.work_anniversary)}
                </div>
              </li>
            {/each}
          </ul>
        </div>
      </div>
    </div>
  </div>
{/if}
